import React from 'react'

function Loading() {
  return (
    <div style={{ textAlign: "center", marginTop: "100px", fontSize: "50px" }}>Loading...</div>
  )
}

export default Loading